<template>
  <div
    class="plan-detail"
    v-loading="checkOutLoading">
    <div class="header">
      <div
        class="title"
        @click="reselect">
        <span class="el-icon-arrow-left"></span><span>Back</span>
      </div>

    </div>
    <div
      class="plan-con"
      :style="{background: plan.background}">
      <div class="title">{{ plan.fakePlanName }}</div>
      <div
        class="choose"
        v-if="existPlan">
        <div>You have chosen a different plan from your previous selection. Any remaining credits will be converted and applied to your new plan.</div>
        <!-- <div>The original remaining time will be converted into the new duration.</div> -->
      </div>
    </div>
    <div class="time-info">
      <div class="remain">Time Remaining</div>
      <div class="time-change">
        <div class="time-format">{{handleQuantity(planQuantitly)}}</div>
        <span class="el-icon-right"></span>
        <div class="time-format new-time">{{handleQuantity(addPlanQuantity)}}</div>
      </div>
    </div>
    <div class="add-wrap">
      <div class="add-title">
        <span>Hours added</span>
        <span class="valid">Hours are valid for up to {{validDate}} months</span>
      </div>
      <div class="title-input">
        <el-input
          v-model="inputAddHours"
          type="number"
          @input="handleInput"
          placeholder="Please input number no more than 4320"></el-input>
        <div>
          <p>Live source: {{ liveSource }}</p>
          <p>Output: {{ output }}</p>
        </div>
      </div>
    </div>
    <div class="pay-footer">
      <div class="price">${{ this.addPlanPrice }}</div>
      <div class="confirm">
        <el-button
          @click="handleCheckOut"
          :disabled="checkOutDisabled">Buy</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { queryPrice, handleNewSub, paymentMethodInfoByIntentId } from '@/common/checkuser.js'
import Helper from '@/common/helper.js'
import { Message } from 'element-ui'
export default {
  props: {
    plan: Object,
    existPlan: Object || null
  },
  inject: ['emailid', 'loadData', 'paySuccess'],
  data () {
    return {
      inputAddHours: null,
      lastInputHours: null,
      addPlanPrice: 0,
      addPlanQuantity: 0,
      HandleQueryPrice: null,
      checkOutLoading: false,
      liveSource: 0,
      output: 0
    }
  },
  created () {
    this.HandleQueryPrice = Helper.debounce(this.handleQueryPrice)

    if (this.plan && this.plan.ChargeItem) {
      const ChargeItem = this.plan.ChargeItem
      this.liveSource = ChargeItem[this.plan.Number]
      this.output = ChargeItem[this.plan.Output]
    }

    if (this.existPlan || this.output) {
      this.handleQueryPrice()
    }
  },
  methods: {
    reselect () {
      this.$emit('reselect')
    },
    // 输入时间
    handleInput (value) {
      if (!value) return this.HandleQueryPrice()
      const input = Number(value)
      if (input > 4320) {
        this.inputAddHours = this.lastInputHours
        Message.warning('Please input the hours no more than 4320')
      } else if (!Number.isInteger(input) || input < 0) {
        this.inputAddHours = this.lastInputHours
      } else {
        this.lastInputHours = input
        this.inputAddHours = input
        this.HandleQueryPrice()
      }
    },
    // 查询价格
    handleQueryPrice () {
      // const addonId = this.plan.chargeItems[0].addonId
      const quantity = Number(this.inputAddHours)
      const chargeItems = {
        [this.plan.Number]: this.plan.input,
        [this.plan.Credit]: quantity,
        [this.plan.Output]: this.output
      }
      let params = {
        customerId: this.emailid,
        product: 'Producer',
        planId: this.plan.planId,
        chargeItems: JSON.stringify(chargeItems)
      }

      queryPrice(params).then(({ data }) => {
        if (data.previewCustomSubscription) {
          this.addPlanPrice = data.previewCustomSubscription.price / 100
          this.addPlanQuantity = data.previewCustomSubscription.quantity
        }
      })
    },
    // 点击 buy
    handleCheckOut () {
      this.checkOutLoading = true
      const quantity = Number(this.inputAddHours)
      const chargeItems = {
        [this.plan.Number]: this.plan.input,
        [this.plan.Credit]: quantity,
        [this.plan.Output]: this.output
      }
      const params = {
        customerId: this.emailid,
        product: 'Producer',
        planId: this.plan.planId,
        chargeItems: JSON.stringify(chargeItems),
        description: `${this.plan.name} ${this.emailid} checkoutSubscription`
      }
      handleNewSub(params, this).then((res) => {
        this.checkOutLoading = false
        // this.loadData()
        console.log(res)
        if (res.checkoutSubscription && res.checkoutSubscription.paymentIntentId) {
          this.paymentInfo(res.checkoutSubscription.paymentIntentId)
        }
      }).catch(err => {
        Message.error({
          message: err.info,
          duration: 5000
        })
        this.checkOutLoading = false
        if (err.type == 'REDIRECT') {
          // 跳到第三方页面， 添加监听页面切回来
          this.handlePayRedirect()
        }
      })
    },
    paymentInfo (paymentIntentId) {
      paymentMethodInfoByIntentId({ paymentIntentId }).then(res => {
        console.log(res)
        if (res.data.paymentMethodInfoByIntentId) {
          const paymentMethodInfoByIntentId = res.data.paymentMethodInfoByIntentId
          const info = {
            'PAYMENT TYPE': paymentMethodInfoByIntentId.card.brand,
            COUNTRY: paymentMethodInfoByIntentId.card.country,
            'PAYMENT METHOD': '**** **** ****' + paymentMethodInfoByIntentId.card.last4,
            'PAYMENT DATE': Helper.timestampToDate(new Date().getTime(), 'MM/DD/YYYY')
          }
          this.paySuccess(info)
        }
      })
    },
    handlePayRedirect () {
      // 只需要监听一次
      const _this = this
      function visibilitychange () {
        if (!window.document.hidden) {
          console.log('visibilitychange')
          _this.loadData()
        }
      }
      window.document.addEventListener('visibilitychange', visibilitychange, { once: true })
    },
    // 处理quantity s
    handleQuantity (value) {
      if (!value || value == 0 || isNaN(value)) {
        return '0h 00min'
      } else {
        let abs = ''
        if (value < 0) {
          abs = '-'
          value = Math.abs(value)
        }
        value = value / 60
        const hour = Math.floor(value / 60)
        let min = Math.ceil(value % 60)
        min = min < 10 ? '0' + min : min
        return `${abs} ${hour}h ${min}min`
      }
    }
  },
  computed: {
    planQuantitly () {
      if (this.existPlan) {
        const chargeItems = this.existPlan.chargeItems
        const chargeItem = chargeItems.find(i => i.addonId == 'producer-time-credit')
        return chargeItem.quantity
      } else {
        return 0
      }
    },
    checkOutDisabled () {
      return this.existPlan ? false : !Number(this.inputAddHours)
    },
    // 转化为 months
    validDate () {
      const ppExpireTime = this.$store.state.initMsg.ppExpireTime
      return Math.floor(ppExpireTime / 1000 / 60 / 60 / 24 / 30)
    }
  }
}
</script>

<style lang="less" scoped>
  .plan-detail {
    width: 408px;
    position: relative;
    .header {
      position: absolute;
      width: 50%;
      top: -60px;

      .title {
        line-height: 24px;
        font-weight: 700;
        font-size: 18px;
        color: var(--dialog-text-color);
        cursor: pointer;
      }
      .el-icon-arrow-left {
        font-weight: 900;
      }

    }

    .plan-con {
      background: linear-gradient(274.86deg, #BDCFF4 0%, #E6EDFA 100%);
      height: 134px;
      padding:30px 0 20px;
      border-radius: 10px;
      .title {
        font-weight: 500;
        font-size: 24px;
        line-height: 16px;
        text-align: center;
        color: #000000;
        margin-bottom: 20px;
      }
      .choose {
        padding: 0 30px;
        word-break: break-word;
        text-align: left;
        font-size: 16px;
        color: #EC5050;
      }
    }

    .time-info {
      // margin: ;
      .remain {
        margin: 20px 0 10px;
        font-size: 20px;
        line-height: 23px;
        color: #585B5D;
      }
      .time-change {
        display: flex;
        justify-content: center;
        align-items: center;
        .el-icon-right {
          font-weight: 900;
          font-size: 18px;
          color: var(--dialog-arrow-color);
          margin: 0 15px;
        }
        .time-format {
          font-size: 16px;
          line-height: 19px;
          color: var(--dialog-text-color);
        }
        .new-time {
          color: #5DC045;
        }
      }
    }

    ::v-deep .title-input {
      .el-input__inner {

      }
      input::-webkit-inner-spin-button {
        display: none;
      }
    }
    .add-wrap {
      text-align: left;
      margin-top: 20px;
      .add-title {
        font-weight: 500;
        line-height: 20px;
        color: var(--dialog-text-color);
        .valid {
          font-size: 12px;
          line-height: 14px;
          color: var(--dialog-text-info-color);
          margin-left: 15px;
        }
      }
      .charge-wrap {
        margin: 5px 0;
        color: var(--dialog-text-info-color);
      }
    }

    .pay-footer {
      display: flex;
      padding: 0 20px;
      margin-top: 40px;
      justify-content: space-between;
      border-top: 2px solid var(--dialog-border-color);
      padding-top: 20px;
      .confirm {
        .el-button {
          width: 80px;
          height: 32px;
          border: none;
          background: #33AB4F;
          color: #FFFFFF;
        }
        .el-button.is-disabled {
          background: #8BC194;
          color: #F0F0F0;
        }
      }
      .price {
        color: #33AB4F;
      }
    }
    .info-line {
      width: calc(100% - 80px);
      margin: 20px auto;
      height: 1px;
      background: var(--dialog-border-color);
    }
    .pay-content {
      height: 200px;
      padding: 0 40px;
      margin: 20px 0;
      // border-top: 1px solid var(--dialog-border-color);
      .info-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 5px 0;
      }
    }
    .pay-start {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: #444444;
      margin: 10px 0;
    }
    .pay-info {
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      color: #979797;
      padding: 0 40px;
      word-break: break-word;
    }

    .all-right {
      margin-top: 50px;
    }
    .trial-footer {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: right;
      position: absolute;
      bottom: 0;
      .close {
        width: 60px;
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 5px 8px;
        float: right;
        margin-right: 10%;
        cursor: pointer;
      }
    }
  }
</style>
